import { render, staticRenderFns } from "./UsersTableOwner.vue?vue&type=template&id=fa270926&"
import script from "./UsersTableOwner.vue?vue&type=script&lang=js&"
export * from "./UsersTableOwner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports